import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Flame, MapPin, ArrowRight, Tag } from "lucide-react";

/** Encart VEDETTE « Bon plan du jour près de [ville] » affiché en haut de la page actu.
 *  Choisit LA meilleure offre publiée (la plus vue) de la ville de l'article ; à défaut,
 *  la meilleure offre du département. Placement compté (channel "press"). */
export default function LocalTopDeal({ city = "", testId = "local-top-deal" }) {
  const [deal, setDeal] = useState(null);
  const [inCity, setInCity] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/offers?status=published&sort=popular&limit=60")
      .then((r) => {
        if (!alive) return;
        const list = Array.isArray(r.data) ? r.data : [];
        const norm = (s) => (s || "").trim().toLowerCase();
        const cityMatch = city ? list.find((o) => norm(o.city) === norm(city)) : null;
        const best = cityMatch || list[0] || null;
        setDeal(best);
        setInCity(!!cityMatch);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [city]);

  useEffect(() => {
    if (deal?.business_id) {
      api.post("/track/editorial-placement", { business_ids: [deal.business_id], channel: "press" }).catch(() => {});
    }
  }, [deal]);

  if (!deal) return null;
  const img = deal.image || (deal.images && deal.images[0]) || null;
  const label = inCity && deal.city ? `Bon plan du jour près de ${deal.city}` : "Bon plan du jour en Eure-et-Loir";

  return (
    <Link to={`/offre/${deal.id}`} data-testid={testId}
      className="group mt-8 flex flex-col sm:flex-row overflow-hidden rounded-2xl border-2 border-[#E05638]/30 bg-gradient-to-br from-orange-50 to-white shadow-sm hover:shadow-lg hover:border-[#E05638] transition-all">
      <div className="sm:w-56 h-40 sm:h-auto shrink-0 bg-slate-100 overflow-hidden relative">
        {img
          ? <img src={img} alt={deal.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          : <div className="w-full h-full grid place-items-center text-[#E05638]/40"><Tag size={40} /></div>}
        {deal.discount && (
          <span className="absolute top-2 left-2 inline-block text-xs font-extrabold text-white bg-rose-500 rounded-full px-2.5 py-1 shadow" data-testid={`${testId}-discount`}>
            {deal.discount}
          </span>
        )}
      </div>
      <div className="flex-1 p-5">
        <div className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-[#E05638]" data-testid={`${testId}-label`}>
          <Flame size={14} /> {label}
        </div>
        <h3 className="mt-2 font-heading text-lg sm:text-xl font-bold text-slate-900 group-hover:text-[#E05638] transition-colors line-clamp-2">{deal.title}</h3>
        {deal.city && <div className="mt-1 text-sm text-slate-500 inline-flex items-center gap-1"><MapPin size={13} /> {deal.city}</div>}
        <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-white bg-[#E05638] group-hover:bg-[#c94a2f] px-4 py-2 rounded-xl transition-colors" data-testid={`${testId}-cta`}>
          En profiter <ArrowRight size={15} />
        </span>
      </div>
    </Link>
  );
}
